"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@mui/styles");
var _notistack = require("notistack");
var _react = _interopRequireDefault(require("react"));
var _SnackbarServiceHost = _interopRequireDefault(require("./SnackbarServiceHost.js"));
var _SnackbarProviderModule = _interopRequireDefault(require("./SnackbarProvider.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Snackbar provider
 *
 * A wrapper around Notistack's own provider to add config overrides.
 */class SnackbarProvider extends _react.default.PureComponent {
  /**
   * Render.
   * 
   * @return {ReactNode}
   */
  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_notistack.SnackbarProvider, {
      anchorOrigin: this.constructor.anchorOrigin,
      classes: this.props.classes,
      className: _SnackbarProviderModule.default.root,
      ...this.props.NotistackProps,
      children: [this.props.children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_SnackbarServiceHost.default, {})]
    });
  }

  /**
   * `anchorOrigin` to apply to Notistack's provider
   *
   * When changed, change `classes` too!
   * 
   * @type {Object}
   */
  static anchorOrigin = {
    horizontal: "center",
    vertical: "bottom"
  };

  /**
   * CSS classes to apply via Material `withStyles()`
   *
   * When changed, change `anchorOrigin` too!
   * 
   * @type {Object}
   */
  static classes = {
    containerAnchorOriginBottomCenter: {
      zIndex: 100000000
    }
  };
}
var _default = exports.default = (0, _styles.withStyles)(SnackbarProvider.classes)(SnackbarProvider);